export type UserPlan = "anonymous" | "free" | "pro" | "studio";

/** Paid tiers. Studio is a superset of Pro (higher AI quota + audience tools). */
export function isPaidPlan(plan: UserPlan): boolean {
  return plan === "pro" || plan === "studio";
}

export function isAuthenticated(plan: UserPlan): boolean {
  return plan !== "anonymous";
}
